import React from 'react';
import { LegalLayout } from '@/components/layout/LegalLayout';

export function CookiesPage() {
  return (
    <LegalLayout title="Cookie Protocol" lastUpdated="May 12, 2026">
      <h2>1. Essence of Cookies</h2>
      <p>
        The Scriptorium utilizes small digital identifiers, known as "cookies," to maintain your session within the Forge. These are essential for the security and continuity of your work.
      </p>

      <h2>2. Essential Session Tokens</h2>
      <p>
        These tokens keep you authenticated as you move between the Desk, the Library, and the Archives. Without them, the Forge would lose track of your identity after every interaction.
      </p>

      <h2>3. Preference Persistence</h2>
      <p>
        We utilize cookies to remember your visual preferences, such as the Dark Mode state and your preferred linguistic density settings for the Scriptorium Engine.
      </p>

      <h2>4. Analytics and Observability</h2>
      <p>
        Anonymous telemetry tokens may be used to observe how scribes interact with the environment, allowing the Master Scribes to optimize the performance of the Forge.
      </p>

      <h2>5. Protocol Control</h2>
      <p>
        You may choose to block these digital identifiers through your browser settings, though doing so will severely limit the functionality of the Scriptorium.
      </p>
    </LegalLayout>
  );
}
